// extracted by mini-css-extract-plugin
export default {"Emojify":"bbo_a bhp_g"};